<template>
    <div>
        <v-main>
            <wzvz_overview :filter="filter" :acco="acco" :key="key"/>
        </v-main>
        <navBar title="Ares - Main menu" :home="true" type="main" />
    </div>
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue";

    import wzvz_overview from '@/components/wzvz/wzvz_overview.vue'

    export default {
        components: {
            navBar,
            wzvz_overview,
        },  
        props: {
            filter: {
                type: String,
                required: false,
                default: "All"
            },
            acco: {
                type: String,
                required: false,
                default: ""
            }
        },  
        data() {
            return {
                key: 1,
            }
        },  
        mounted() {
            // console.log(this.filter);
        },  
        watch: {
            filter() {
                // Reload pagina als dit wijzigd.
                this.key = this.key + 1;
            }
        },
        methods: {     
        }

    }
</script>

<style scoped> 

</style>